import $ from "jQuery";

$('.ce_rsce_text_mit_bild .mehr-anzeigen').on('click',function(){
    $(this).prev().slideDown();
    $(this).slideUp();
});